module.exports = __webpack_public_path__ + "img/liveCourse.46982cb4.png";